import PatientProfileDrawer from './PatientProfileDrawer';
export default PatientProfileDrawer;
